/**
 * @module sitn.mobile.Controller
 */
/**
 * Application entry point.
 *
 * This file defines the "sitn_mobile" Closure namespace, which is be used as the
 * Closure entry point (see "closure_entry_point" in the "build.json" file).
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */

import './sass/mobile.scss';

import angular from 'angular';
import gmfControllersAbstractMobileController, {
  AbstractMobileController,
} from 'gmf/controllers/AbstractMobileController.js';
import sitnBase from '../index.js';

import olStyleFill from 'ol/style/Fill.js';
import olStyleRegularShape from 'ol/style/RegularShape.js';
import olStyleStroke from 'ol/style/Stroke.js';
import olStyleStyle from 'ol/style/Style.js';

if (!window.requestAnimationFrame) {
  alert(
    "Votre navigateur n'est pas supporté, veuillez le mettre à jour ou en utiliser un autre. Vous allez être redirigé.",
  );
  window.location = 'https://www.ne.ch/autorites/DDTE/SGRF/SITN/geoportail/Pages/accueil.aspx';
}

/**
 * @private
 */
class Controller extends AbstractMobileController {
  /**
   * @param {angular.IScope} $scope Scope.
   * @param {angular.auto.IInjectorService} $injector Main injector.
   */
  constructor($scope, $injector) {
    super($scope, $injector);

    /**
     * @type {import("ol/style/Style.js").default}
     */
    this.measureSketchStyle = new olStyleStyle({
      fill: new olStyleFill({
        color: 'rgba(255, 0, 0, 0.2)',
      }),
      stroke: new olStyleStroke({
        color: 'rgba(128, 0, 0, 0.5)',
        lineDash: [10, 10],
        width: 2,
      }),
      image: new olStyleRegularShape({
        stroke: new olStyleStroke({
          color: 'rgba(128, 0, 0, 0.7)',
          width: 2,
        }),
        points: 4,
        radius: 8,
        radius2: 0,
        angle: 0,
      }),
    });

    window['sitnExterns'] = {};
    window['sitnExterns']['sitn_servitudes_url'] = $injector.get('sitnServitudesUrl');
    window['sitnExterns']['sitn_sau_list_url'] = $injector.get('sitnSauUrl');
    window['sitnExterns']['openTab'] = (baseUrl, paramString) => {
      let url = baseUrl;
      if (baseUrl in window['sitnExterns']) {
        url = window['sitnExterns'][baseUrl];
      }
      if (paramString && paramString !== '') {
        url += `?${paramString}`;
      }
      const win = window.open(url, '_blank');
      if (win) {
        win.focus();
      } else {
        alert("Merci d'autoriser l'ouverture de fenêtres supplémentaires");
      }
    };

    window['sitnExterns']['openUrl'] = function (base_url, suffix, param_string) {
      const url = window['sitnExterns'][base_url];
      const win = window.open(url + '/' + suffix + '?' + param_string, '_blank');
      if (win) {
        win.focus();
      } else {
        alert("Merci d'autoriser l'ouverture de fenêtres supplémentaires");
      }
    };

    window['gOpenWindow'] = function (title, url, width, height, x = 0, y = 0) {
      title, width, height;
      const win = window.open(url, '_blank');
      if (win) {
        win.focus();
      } else {
        alert("Merci d'autoriser l'ouverture de fenêtres supplémentaires");
      }
    };
    window['sitnExterns']['openWindow'] = window['gOpenWindow'];
  }
}

Controller.$inject = ['$scope', '$injector'];

const sitnModule = angular.module('Appmobile', [
  sitnBase.module.name,
  gmfControllersAbstractMobileController.name,
]);

sitnModule.controller('MobileController', Controller);

export default sitnModule;
